import { SelectItem } from "@mantine/core"
import { WittyPiSchedule } from "../../hooks/useParseSchedule"
import { Locator } from "../../../../contexts/language-context"

export default (L: Locator) =>
    [
        {
            value: "15m_sunrise_15m",
            label: L("%s minutes before and %s minutes after %s", 15, 15, L("sunrise")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 15,
                    postBuffer: 15,
                },
            ],
        },
        {
            value: "15m_sunset_15m",
            label: L("%s minutes before and %s minutes after %s", 15, 15, L("sunset")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunset",
                    preBuffer: 15,
                    postBuffer: 15,
                },
            ],
        },
        {
            value: "15m_sunrise__15m_sunset_15m",
            label: `${L("%s minutes before and %s minutes after %s", 15, 15, L("sunrise"))}. ${L(
                "%s minutes before and %s minutes after %s",
                15,
                15,
                L("sunset"),
            )}`,
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 15,
                    postBuffer: 15,
                },
                {
                    type: "sunset",
                    preBuffer: 15,
                    postBuffer: 15,
                },
            ],
        },
        {
            value: "30m_sunrise_30m",
            label: L("%s minutes before and %s minutes after %s", 30, 30, L("sunrise")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 30,
                    postBuffer: 30,
                },
            ],
        },
        {
            value: "30m_sunset_30m",
            label: L("%s minutes before and %s minutes after %s", 30, 30, L("sunset")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunset",
                    preBuffer: 30,
                    postBuffer: 30,
                },
            ],
        },
        {
            value: "30m_sunrise__30m_sunset_30m",
            label: `${L("%s minutes before and %s minutes after %s", 30, 30, L("sunrise"))}. ${L(
                "%s minutes before and %s minutes after %s",
                30,
                30,
                L("sunset"),
            )}`,
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 30,
                    postBuffer: 30,
                },
                {
                    type: "sunset",
                    preBuffer: 30,
                    postBuffer: 30,
                },
            ],
        },
        {
            value: "1h_sunrise_1h",
            label: L("1 hour before and 1 hour after %s", L("sunrise")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 60,
                    postBuffer: 60,
                },
            ],
        },
        {
            value: "1h_sunset_1h",
            label: L("1 hour before and 1 hour after %s", L("sunset")),
            group: L("Preset"),
            lines: [
                {
                    type: "sunset",
                    preBuffer: 60,
                    postBuffer: 60,
                },
            ],
        },
        {
            value: "1h_sunrise__1h_sunset_1h",
            label: `${L("1 hour before and 1 hour after %s", L("sunrise"))}. ${L(
                "1 hour before and 1 hour after %s",
                L("sunset"),
            )}`,
            group: L("Preset"),
            lines: [
                {
                    type: "sunrise",
                    preBuffer: 60,
                    postBuffer: 60,
                },
                {
                    type: "sunset",
                    preBuffer: 60,
                    postBuffer: 60,
                },
            ],
        },
        {
            value: "reboot_nightly",
            label: L("Reboot nightly"),
            group: L("Preset"),
            lines: [{ start: "00:00:00", end: "23:54:00" }],
        },
        {
            value: "wake_daily_noon",
            label: L("Wake at noon (power-saving)"),
            group: L("Preset"),
            lines: [{ start: "12:00:00", end: "12:05:00" }],
        },
        {
            value: "wake_sunday_night",
            label: L("Wake Sunday night (extreme power-saving)"),
            group: L("Preset"),
            lines: [{ start: "23:54:59", end: "23:59:59" }],
            dayPattern: [false, false, false, false, false, false, true],
        },
    ] satisfies (WittyPiSchedule & SelectItem)[]
